// pin the app timezone to Asia/Tehran before anything imports a date library
import "./utils/timezone";
// react
import React from "react";
import ReactDOM from "react-dom/client";
// components
import App from "./App";
// providers
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
// web vitals
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
serviceWorkerRegistration.unregister();
// serviceWorkerRegistration.register();
